export default __webpack_public_path__ + "static/media/lindsay.19fdc9d9.jpg";